export default __webpack_public_path__ + "static/interval-films-logo-f11862198dbe268028f599088c02f64e.png";